import * as React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import PropTypes from 'prop-types'
import { GatsbyImage } from 'gatsby-plugin-image'
import { filterProducts } from '../utils/Utils'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function FooterComponent({ title, partnerseite }) {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      allWpCategory(filter: { name: { ne: "Uncategorized" } }) {
        nodes {
          name
          slug
          rwProducts {
            nodes {
              id
            }
          }
        }
      }
    }
  `)

  const darkMode = partnerseite.identity?.invertDefaultMenu
  const productIdsToFilter = partnerseite.disableProducts

  const overviewNavItems = [
    {
      name: 'Kontakt',
      href: '/kontakt',
    },
    {
      name: 'Impressum',
      href: '/impressum',
    },
    {
      name: 'Datenschutz',
      href: '/datenschutz',
    },
    {
      name: 'AGB',
      href: '/agb',
    },
  ]
  const supportNavItems = [
    {
      name: partnerseite.kontakt.email,
      href: `mailto:${partnerseite.kontakt.email}`,
    },
    {
      name: partnerseite.kontakt.tel,
      href: `tel:${partnerseite.kontakt.telLink}`,
    },
    {
      name: partnerseite.kontakt.tel2,
      href: `tel:${partnerseite.kontakt.tel2Link}`,
    },
    { name: 'Alle Preise netto, exkl. 19% USt.', href: false },
  ]
  return (
    <footer className={classNames(darkMode && 'dark', 'text-white bg-black')}>
      <div className="grid gap-12 px-4 py-8 overflow-hidden md:py-24 sm:grid-cols-2 md:grid-cols-4 sm:p-8 md:px-12 md:gap-24">
        <div>
          <div className="relative pointer-events-none">
            {!darkMode &&
              (partnerseite.identity?.navigationDesktop?.localFile
                ?.extension !== 'svg' ? (
                <GatsbyImage
                  className="w-auto max-w-[11rem] mb-4 z-10"
                  image={
                    partnerseite.identity?.navigationDesktop?.localFile
                      ?.childImageSharp?.gatsbyImageData
                  }
                  alt="logo"
                />
              ) : (
                <img
                  className="w-auto max-w-[11rem] mb-4 z-10 min-h-[5rem]"
                  src={
                    partnerseite.identity?.navigationDesktop?.localFile
                      ?.publicURL
                  }
                  alt="logo"
                />
              ))}
            {darkMode &&
              (partnerseite.identity?.invertiertesLogoOptional?.localFile
                ?.extension !== 'svg' ? (
                <GatsbyImage
                  className="w-auto max-w-[11rem] mb-4 z-10"
                  image={
                    partnerseite.identity?.invertiertesLogoOptional?.localFile
                      ?.childImageSharp?.gatsbyImageData
                  }
                  alt="logo"
                />
              ) : (
                <img
                  className="w-auto max-w-[11rem] mb-4 z-10 min-h-[5rem]"
                  src={
                    partnerseite.identity?.invertiertesLogoOptional?.localFile
                      ?.publicURL
                  }
                  alt="logo"
                />
              ))}
            <div className="absolute bg-white rounded-full w-44 h-44 -top-24 blur-xl opacity-20" />
            <div className="absolute w-16 h-16 bg-white rounded-full opacity-20 -top-2 left-12 blur-xl" />
            <div className="absolute bg-blue-300 rounded-full -top-12 left-1/4 w-52 h-52 blur-xl opacity-20" />
            <div className="absolute right-0 bg-red-600 rounded-full -top-32 w-44 h-44 blur-xl opacity-20" />
            <div className="absolute bg-red-600 rounded-full -left-16 -top-2 w-44 h-44 blur-xl opacity-20" />
          </div>
          <div>
            Sicherheits­technik zur flexiblen Miete.
            <br />
            {title} ist Ihr erfahrener Partner und Sicherheits­technik-Experte.
            Gemeinsam schützen wir Events, Baustellen, Anlagen und vieles mehr.
          </div>
        </div>
        <div>
          <h3 className="mb-6 font-medium">Sicherheitstechnik mieten</h3>
          <ul className="space-y-4">
            <li>
              <Link
                className="hover:text-gray-300 hover:underline"
                to="/produkte"
              >
                Alle Produkte
              </Link>
            </li>
            {data.allWpCategory.nodes.map(category => {
              const categoryProducts = filterProducts(
                category.rwProducts.nodes,
                productIdsToFilter
              )
              if (categoryProducts.length < 1) return
              return (
                <li key={category.slug}>
                  <Link
                    className="hover:text-gray-300 hover:underline"
                    to={`/kategorien/${category.slug}`}
                  >
                    {category.name}
                  </Link>
                </li>
              )
            })}
          </ul>
        </div>
        <div>
          <h3 className="mb-6 font-medium">Übersicht</h3>
          <ul className="space-y-4">
            {overviewNavItems
              .filter(elem => {
                if (elem === null || elem === undefined) return false
                return true
              })
              .map(overviewNavItem => (
                <li key={overviewNavItem.name}>
                  <Link
                    className="hover:text-gray-300 hover:underline"
                    to={overviewNavItem.href}
                  >
                    {overviewNavItem.name}
                  </Link>
                </li>
              ))}
          </ul>
        </div>
        <div className="relative">
          <h3 className="mb-6 font-medium">Support</h3>
          <ul className="space-y-4">
            {supportNavItems
              .filter(elem => {
                if (elem.name === null || elem.name === undefined) return false
                return true
              })
              .map(supportNavItem => (
                <li key={supportNavItem.name}>
                  {supportNavItem.href ? (
                    <a
                      className="hover:text-gray-300 hover:underline"
                      href={supportNavItem.href}
                    >
                      {supportNavItem.name}
                    </a>
                  ) : (
                    <div>{supportNavItem.name}</div>
                  )}
                </li>
              ))}
          </ul>
          <div className="absolute w-64 h-64 bg-blue-300 rounded-full pointer-events-none -bottom-12 right-1/4 blur-xl opacity-10" />
          <div className="absolute right-0 bg-red-600 rounded-full pointer-events-none -bottom-32 w-44 h-44 blur-xl opacity-20" />
          <div className="absolute bg-white rounded-full pointer-events-none -right-16 -bottom-2 w-44 h-44 blur-xl opacity-10" />
        </div>
      </div>
      <div className="py-8 mx-4 border-t border-gray-600">
        © {new Date().getFullYear()} {partnerseite.legal.firmenbezeichnung}. All
        rights reserved.
        <br />
        Powered by
        {` `}
        <a
          href={`https://rentware.com/?utm_source=${title
            .replace(/\s+|\-+/g, '_')
            .toLowerCase()}_website&utm_medium=footer_link&utm_campaign=ref&utm_content=de`}
        >
          Rentware
        </a>
      </div>
    </footer>
  )
}

export default FooterComponent

FooterComponent.propTypes = {
  title: PropTypes.string.isRequired,
  partnerseite: PropTypes.object,
  overviewNavItems: PropTypes.exact({
    name: PropTypes.string,
    href: PropTypes.string,
  }),
  supportNavItems: PropTypes.exact({
    name: PropTypes.string,
    href: PropTypes.string,
  }),
}
